import React, { useState, useEffect } from 'react';
import { DataGrid, GridPagination } from '@mui/x-data-grid';
import { requestApi } from 'app/utils/RestApi';
import moment from 'moment';
import { Col, Row } from 'react-bootstrap';
import Div from '@jumbo/shared/Div';
import ButtonStyled from '../ButtonStyled';
import InputSearch from '../InputSearch';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { COMMON } from 'app/utils/constants/endPoint';
import Link from "@mui/material/Link";
import Swal from 'sweetalert2';

const DataTable = ({ columns, endPoint, downloadUrl = '', filterData = [], policyNo = '', customContent, showFilter = true }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [isDateFilterApplied, setIsDateFilterApplied] = useState(false);
  const [isFilterButtonEnabled, setIsFilterButtonEnabled] = useState(false);
  const [isDownloadButtonEnabled, setIsDownloadButtonEnabled] = useState(false);
  const [filteredDataStartId, setFilteredDataStartId] = useState(1);

  // Guard against React Strict Mode double-invoke
  const hasInitialized = React.useRef(false);


  const [params, setParams] = useState({
    pageIndex: 0,
    pageSize: 10,
    orderBy: '',
    orderBehavior: '',
    searchValue: null,
    searchBy: '',
    refCode: ''
  });

  const [tableData, setTableData] = useState({
    pageNumber: 0,
    pageSize: 10,
    totalElements: 0,
    totalPages: 0,
    items: []
  });

  const [tableDataFilter, setTableDataFilter] = useState({
    pageNumber: 0,
    pageSize: 10,
    totalElements: 0,
    totalPages: 0,
    items: []
  });

  useEffect(() => {
    if (params.searchValue !== null) {
      fetchData()
    }
  }, [params.searchValue])

  useEffect(() => {
    if (params.searchBy != '' && params.searchValue) {
      fetchData()
    }
  }, [params.searchBy])

  const handleSearch = (value) => {
    setParams((prevState) => ({ ...prevState, searchValue: value }));
  };

  const handlechangePage = (e) => {
    setParams((prevState) => ({ ...prevState, pageIndex: e.page, pageSize: e.pageSize }));
  }

  function base64ToXls(base64String) {
    const currentDate = new Date();
    const time = currentDate.getTime();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const fileName = `download_${year}_${month}_${day}_${time}.xls`;

    // Remove the data URL prefix
    const dataUrlPrefix = 'data:application/vnd.ms-excel;base64,';
    const base64Data = base64String.replace(dataUrlPrefix, '');

    // Convert Base64 to a Blob
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/vnd.ms-excel' });

    // Create a download link and trigger the download
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = fileName;
    downloadLink.click();
  }


  const downloadData = async () => {
    // setIsLoading(true)
    let newReqParam = {}

    for (let [_, key] of Object.keys(params).entries()) {
      if (params[key] != '' && !['pageSize', 'pageIndex'].some(s => s === key)) {
        newReqParam[key] = params[key]
      }
    }

    const userdata = localStorage.getItem('userdata')
    const dataLogin = JSON.parse(userdata)

    // newReqParam['refCode'] = dataLogin.userLoggedin.referrerCode;
    // if (policyNo) {
    //   newReqParam['policyNo'] = policyNo
    // }

    const data = {
      refCode: dataLogin.userLoggedin.referrerCode
      // refCode: 'RA000001'
    }
    if (policyNo) {
      data['policyNo'] = policyNo
    }

    console.log("request export : ", data);


    await Swal.fire({
      title: 'Mohon Tunggu..',
      timerProgressBar: true,
      didOpen: async () => {
        Swal.showLoading()
        try {
          const res = await requestApi(downloadUrl, {
            params: data
          })
          Swal.close();
          if (downloadUrl !== COMMON.TNC_DOWNLOAD) {
            const objectURL = URL.createObjectURL(
              new File([res.data], downloadUrl + '_', { type: ".xlsx" })
            );
            const downloadLink = document.createElement("a");
            document.body.appendChild(downloadLink);
            downloadLink.href = objectURL;
            downloadLink.download = downloadUrl + '_' + moment().format('DD-MM-YYYY-HH-mm') + ".xlsx";

            downloadLink.style.display = "none";
            downloadLink.click();
            document.body.removeChild(downloadLink);
          } else {
            const dataFile = res.data.data
            if (dataFile.data) {
              var base64 = (dataFile.base64File) ? dataFile.base64File : dataFile;
              base64ToXls(base64)
            }
          }

        } catch (error) {
          Swal.fire({
            icon: 'warning',
            text: error?.message || 'Bad request!',
            title: "Error",
            allowOutsideClick: false,
            confirmButtonColor: 'red'
          })
        }
      },
      showCloseButton: false,
      showConfirmButton: false,
      allowOutsideClick: false
    })



  }

  useEffect(() => {
    if (hasInitialized.current) return;
    hasInitialized.current = true;
    fetchData()
  }, []);

  const fetchData = async () => {
    setIsLoading(true);

    let newReqParam = {};
    const userdata = localStorage.getItem('userdata');
    const dataLogin = JSON.parse(userdata);
    console.log(dataLogin.userLoggedin.referrerCode);

    if (dataLogin?.userLoggedin?.referrerCode) {
      newReqParam.refCode = dataLogin.userLoggedin.referrerCode;
    }

    if (policyNo) {
      newReqParam.policyNo = policyNo;
    }

    try {
      const { data } = await requestApi(endPoint, {
        params: {
          ...params,
          ...newReqParam,
        },
      })
      setIsLoading(false);
      if (data?.status == 'success') {
        const dataTb = data.data;
        const arrayData = dataTb.items;

        // Assign incremental IDs to fetched data
        if (arrayData) {
          const dataWithIds = arrayData.map((item, index) => ({
            ...item,
            id: index + 1,
          }));

          dataTb.items = dataWithIds;
          setTableData(dataTb);
        }

        setIsFilterButtonEnabled(arrayData.length !== 0);
        setIsDownloadButtonEnabled(downloadUrl !== null && arrayData.length !== 0);
      }
    } catch (error) {
      Swal.fire({
        icon: 'warning',
        text: error?.message || 'Bad request!',
        title: "Error",
        allowOutsideClick: false,
        confirmButtonColor: 'red'
      })
      setIsLoading(false);
    }


  };


  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const filterDataByDateRange = () => {
    if (startDate && endDate) {
      const filteredData = tableData.items.filter((item) => {
        const itemDate = new Date(item.createdDate);
        const start = new Date(startDate);
        const end = new Date(endDate);
        return itemDate >= start && itemDate <= end;
      });

      // Reset the filtered data start ID to 1
      setFilteredDataStartId(1);

      setFilteredTableData(filteredData.map((item, index) => ({
        ...item,
        id: filteredDataStartId + index,
      })));
      setIsDateFilterApplied(true);
    } else {
      // If no date range is selected, reset the filtered data.
      setFilteredTableData([]);
      setIsDateFilterApplied(false);
    }
  };



  const handleEnter = (value) => {
    setParams((prevState) => ({ ...prevState, searchValue: value }));
  };

  const resetTable = () => {
    setStartDate(null);
    setEndDate(null);
    setIsDateFilterApplied(false);
    setParams({
      pageIndex: 0,
      pageSize: 10,
      orderBy: '',
      orderBehavior: '',
      searchValue: null,
      searchBy: '',
      refCode: ''
    });
    setTableData({
      pageNumber: 0,
      pageSize: 10,
      totalElements: 0,
      totalPages: 0,
      items: []
    });
    setTableDataFilter({
      pageNumber: 0,
      pageSize: 10,
      totalElements: 0,
      totalPages: 0,
      items: []
    });
    fetchData();
  };

  const CustomNoRowsOverlay = () => (
    <Div sx={{ textAlign: 'center', fontWeight: 600, pt: 5, fontSize: "16px" }}>Tidak ada data untuk ditampilkan</Div>
  );

  return (
    <Div sx={{ padding: '24px' }}>
      {
        showFilter &&
        <Row className='table-search-container'>
          <Col lg={6} md={12}>
            <Div className='flex-justify-start'>
              <Div sx={{ mr: "16px" }}>
                <DatePicker
                  className='global-datepicker'
                  selected={startDate}
                  onChange={handleStartDateChange}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  placeholderText='Date From'
                  dateFormat="MMMM d, yyyy"
                  isClearable
                  showYearDropdown
                  scrollableYearDropdown
                  leftIcon={<CalendarMonthIcon sx={{ fontSize: 24 }} />}
                />
              </Div>
              <Div sx={{ mr: "16px" }}>
                <DatePicker
                  className='global-datepicker'
                  selected={endDate}
                  onChange={handleEndDateChange}
                  selectsEnd
                  placeholderText='Date To'
                  startDate={startDate}
                  endDate={endDate}
                  minDate={startDate}
                  dateFormat="MMMM d, yyyy"
                  isClearable
                  showYearDropdown
                  scrollableYearDropdown
                  leftIcon={<CalendarMonthIcon sx={{ fontSize: 24 }} />}
                />
              </Div>

              {isFilterButtonEnabled ? (
                <Div sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                  <ButtonStyled
                    size="small"
                    fullWidth={false}
                    preset="round"
                    btnText={"Filter"}
                    onClick={filterDataByDateRange}
                  />
                </Div>
              ) : (
                <Div sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                  <ButtonStyled
                    size="small"
                    fullWidth={false}
                    preset="round"
                    btnText={"Filter"}
                    disabled
                    onClick={filterDataByDateRange}
                  />
                </Div>
              )}

              <Div sx={{ display: 'flex', justifyContent: 'flex-start', marginLeft: '8px' }}>
                <ButtonStyled
                  size="small"
                  fullWidth={false}
                  preset="secondaryRound"
                  btnText={"Reset"}
                  onClick={resetTable}
                />
              </Div>
            </Div>
          </Col>
          <Col lg={6} md={12}>
            <Div className='flex-justify-end'>
              <Div sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                <InputSearch onEnter={handleEnter} onBlur={handleSearch} sx={{}} />
              </Div>
            </Div>
          </Col>
        </Row>
      }
      <Div className='flex-justify-end' sx={{ margin: '16px 0' }}>
        {downloadUrl != '' ? (
          <Div>
            <Link underline="hover" color="inherit" onClick={downloadData} sx={{ cursor: "pointer" }}>
              <img src={`${process.env.REACT_APP_IMAGES_PATH}/download.png`} />
            </Link>
          </Div>
        ) : (
          <Div>
          </Div>
        )}
      </Div>
      <div style={{ height: 400, marginTop: '10px', width: '100%' }}>
        <DataGrid
          className='data-table'
          loading={isLoading}
          rows={isDateFilterApplied ? filteredTableData : tableData.items}
          columns={columns}
          pageSize={tableData.pageSize}
          pagination
          onPaginationModelChange={handlechangePage}
          slots={{
            noRowsOverlay: CustomNoRowsOverlay,
            noResultsOverlay: CustomNoRowsOverlay,
            footer: () => (
              <>
                {customContent}
                <GridPagination />
              </>
            )
          }}
        />
      </div>

    </Div>
  );
};

export default DataTable;